import { instance } from '../instance'

/**
 * Update user data
 *
 * @param data
 * @param validate
 * @returns {Promise<AxiosResponse<any>>}
 */
export const update = async (data = {}, validate = 1) => {
  return instance.patch('/v2/user', data, {
    params: {
      validate: Number(validate),
    },
  })
}
